import { Popover } from "react-bootstrap";
import styled from "styled-components";

export const NotificationPopover = styled(Popover)`
  &.popover {
    max-width: 450px;
    width: 450px;
    background: ${({ theme }) => theme.dropdown.bg.primary};
    height: auto;
    max-height: calc(100vh - 80px);
    overflow: scroll;
  }

  .body-wrapper {
    padding: 0 0 10px;

    .list-group-item {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      border-radius: 10px;
      margin: 0px 4px 0px 7px;
      min-height: 70px;
      border: 0;
      padding-top: 0px;
    }

    .seen {
      .dot {
        background-color: ${({ theme }) => theme.global.color.bodyColor};
      }
    }

    .no-data {
      background: ${({ theme }) => theme.dropdown.bg.primary};
      opacity: 0.5;
    }
  }

  .list-group {
    border-radius: 0;
  }

  .popover-arrow::after {
    border-bottom-color: ${({ theme }) => theme.dropdown.bg.primary};
  }

  .popover-header {
    background-color: ${({ theme }) => theme.modal.bg.secondary};
    color: ${({ theme }) => theme.card.font.tertiary};
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0px;

    span {
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      width: 100%;
    }

    &:before {
      border: none;
    }

    .mobile-view {
      padding-top: 0;
    }
  }

  .mark-as-read {
    text-align: right;
    margin-bottom: 10px;
    padding: 0 10px;

    button {
      padding: 8px 18px;
      border: none;
      font-size: 14px !important;
      margin-right: 0;
      color: ${({ theme }) => theme.button.bg.primary};
    }
  }

  .actions {
    text-align: center;

    button {
      padding: 8px 18px;
      border: none;
      font-size: 14px !important;
      // color: ${({ theme }) => theme.button.bg.primary};
    }
  }

  @media screen and (max-width: 500px) {
    &.popover {
      max-width: 90%;
      width: 90%;
      top: 130px !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
    }
  }
`;

export const NotificationCardContainer = styled.div`
  display: flex;
  justify-content: space-between;

  .dot {
    min-height: 9px;
    margin-right: 8px;
    min-width: 9px;
    background-color: #0a76e1;
    border-radius: 50%;
    display: inline-block;
  }

  .description {
    margin: 0 12px;
    cursor: pointer;
  }

  .time {
    opacity: 0.5;
  }

  .profile {
    height: 40px;
    width: 40px;
  }

  .action .btn-action {
    padding: 6px 20px;
  }

  .no-avatar img {
    padding: 5px;
  }

  .icon-close:focus {
    box-shadow: none;
  }
`;

export const NotificationContainer = styled.div`
  h2 {
    margin-bottom: 0;
  }

  .wrapper {
    margin: 0 -10px;
    margin-top: 12px;

    .list-group-item {
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      margin: 0px 8px 0px 7px;
      min-height: 70px;
      border: 0;
      padding-top: 0px;
    }

    .list-group {
      border-radius: 0;
    }

    .seen {
      .dot {
        background-color: ${({ theme }) => theme.global.color.bodyColor};
      }
    }

    .no-data {
      text-align: center;
      opacity: 0.5;
    }
  }

  .mark-as-read {
    text-align: right;
    margin-bottom: 10px;
    padding: 0 10px;

    button {
      padding: 8px 18px;
      border: none;
      font-size: 14px !important;
      margin-right: 0;
      color: ${({ theme }) => theme.button.bg.primary};
    }
  }

  @media (max-width: 1200px) {
    padding: 0;
  }
`;

export const NotificationCount = styled.div`
  position: relative;

  .indicator {
    position: absolute;
    left: 53%;
    top: 21%;
    height: 6px;
    width: 6px;
    background-color: #048af5;
    border-radius: 50%;
  }

  .count {
    position: absolute;
    background: ${({ theme }) => theme.button.bg.primary};
    border-radius: 50%;
    font-size: 10px;
    font-weight: 600;
    border: 2px solid ${({ theme }) => theme.global.bg.primary};
    bottom: -5px;
    right: -10px;
    width: 21px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
`;
